// Vendors
import { useEffect, useState } from 'react';
import { useElements, useStripe } from '@stripe/react-stripe-js';
// Contexts
import { useFetchErrorContextConsumerHook } from 'contexts/fetch-error.context';
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
import { usePaymentContextConsumerHook } from 'containers/payment/contexts/payment.context';
// Event Handlers
import { PaymentLandingFormHandlers } from '../handlers/payment-landing-form.handlers';
import { PaymentLandingFormTrackingHandlers } from '../handlers/payment-landing-form.tracking.handlers';
// Hooks
import { useAppTrackingHook } from 'tracking/app-tracking.hook';
// Types
import { PaymentLandingFormMethodsHandlersType } from '../handlers/types/payment-landing-form.handlers.type';

const usePaymentLandingFormHook = (): Pick<
  PaymentLandingFormMethodsHandlersType,
  'handlePaymentFormComplete'
> => {
  const stripe = useStripe();
  const elements = useElements();
  const { setError } = useFetchErrorContextConsumerHook(),
    { setButtonGhostConfiguration, setMainButtonConfiguration } = useLayoutContextConsumerHook(),
    { cardCountry } = usePaymentContextConsumerHook();

  const [completeForm, setCompleteForm] = useState(false);

  const { handleTrackPayButtonClick } = useAppTrackingHook(PaymentLandingFormTrackingHandlers);

  const { handlePaymentLandingFormButtonConfiguration, handlePaymentFormComplete } =
    PaymentLandingFormHandlers({
      cardCountry,
      completeForm,
      elements,
      handleTrackPayButtonClick,
      setButtonGhostConfiguration,
      setCompleteForm,
      setError,
      setMainButtonConfiguration,
      stripe,
    });

  useEffect(() => {
    handlePaymentLandingFormButtonConfiguration();
  }, [stripe, elements, completeForm]);

  return { handlePaymentFormComplete };
};

export { usePaymentLandingFormHook };
